import { Link } from 'react-router-dom';

export function Brand() {
  return (
    <Link className="brand" to="/" aria-label="SCAN90 LAB ホーム">
      <span className="brand-mark" aria-hidden="true">90</span>
      <span className="brand-word">
        <strong>SCAN90 LAB</strong>
        <small>サッカー認知トレーニング</small>
      </span>
    </Link>
  );
}
